const organizationIdActions = {
  ORGANIZATION_ID_SET: 'ORGANIZATION_ID_SET'
};

export default organizationIdActions;